import { Element } from "@craftjs/core";
import { Box, Card, Stack, Typography } from "@mui/material";
import React from "react";
import cn from "clsx";
import Image from "next/image";
import {useQuery} from "@tanstack/react-query";
import {getProductById} from "@/src/api/services/products";
import {Action as Button} from "@/src/components/Action";
import { FlexBox } from "@/src/components/FlexBox";

interface ProductCardProps {
    title: string;
    description: string;
    imageUrl: string;
    image?: { src: string; alt: string };
    termsUrl: string;
    className?: string;
    style?: any;
    productId: string;
    mode: string;
    slug: string;
    status?: string;
}
export function ProductCardDemo (props: ProductCardProps) {
    const {className, productId, mode, style, slug } = props;
    const {data, isLoading } = useQuery({
        queryKey: ["PRODUCT_KEY", productId],
        queryFn: () => getProductById({ id: productId as string }),
        enabled: !!productId && mode === "source",
    });

    const title = data?.title || props.title;
    const description = data?.description || props.description;
    const imageUrl = data?.imageUrl || props.image?.src || props.imageUrl;
    const alt = props.image?.alt || props.title
    const termsUrl = data?.termsUrl || props.termsUrl;
    const status = data?.status || props.status;

    if (isLoading) {
        return <Card className={cn("min-h-[298px] w-full h-full p-0 flex flex-col", className)} style={style}/>;
    }

    const isValidUrl = imageUrl && (imageUrl.startsWith("http") || imageUrl.startsWith("/"));

    return (
        <Card className={cn("min-h-[298px] w-full h-full p-0 flex flex-col", className)} style={style}>
            {isValidUrl && (
                <Box className={"my-0 mx-auto w-full"}>
                    <Image
                        src={imageUrl}
                        alt={alt} width={400} height={190} sizes="100vw"
                        style={{
                            width: '100%',
                            height: '190px',
                            objectFit: 'cover',
                        }}
                    />
                </Box>
            )}
            <Stack className={"gap-4 p-4 flex-1"}>
                <div className={"flex-1"}>
                    {title && (
                        <Typography component={"h4"} variant={"h4"} sx={{color: "#234678"}}>
                            {title}
                        </Typography>
                    )}
                    {description && <Typography component={"p"}>{description}</Typography>}
                </div>
                <Element key={productId} is={FlexBox} id={`navigation-${productId}`} className={"p-0 gap-2"}>
                    <Element is={Button} fullWidth variant={"outlined"} methods={[{method: "open_link", params: {target: "_blank", href: termsUrl || "/"}}]}>{"Умови"}</Element>
                    <Element is={Button} fullWidth methods={[{method: "open_link", params: {target: "_blank", href: `/products/${slug}`}}]} disabled={status === "INACTIVE"}>{"Купити онлайн"}</Element>
                </Element>
            </Stack>
        </Card>
    );
};

ProductCardDemo.displayName = "ProductCard";
